<template>
    <div class="flex flex-col gap-2">
        <ElementsTooltipSingleton
            :ref="handleTooltipElementReady"
        />

        <div class="flex items-center gap-1">
            <p class="font-inter-body-1 text-content-basic-1">
                {{ label }}
            </p>
            <button
                v-if="tooltip"
                type="button"
                class="flex items-center"
                :ref="(el) => handleTooltip(el, () => tooltip)"
            >
                <InfoIcon :width="18" :height="18" color="text-primary-3" weight="REGULAR" />
            </button>
        </div>

        <div class="flex items-center gap-4">
            <button
                type="button"
                class="flex items-center gap-1"
                @click="setValue('N')"
            >
                <span
                    class="flex h-3 w-3 items-center justify-center rounded-full border border-border-basic-2"
                    :class="isLocked ? 'border-primary-3' : ''"
                >
                    <span
                        v-if="isLocked"
                        class="h-1.5 w-1.5 rounded-full bg-primary-3"
                    ></span>
                </span>
                <span
                    :class="isLocked ? 'font-inter-body-2 text-primary-3' : 'font-inter-body-sm-regular text-content-basic-2'"
                >
                    Lock Approver
                </span>
            </button>

            <button
                type="button"
                class="flex items-center gap-1"
                @click="setValue('Y')"
            >
                <span
                    class="flex h-3 w-3 items-center justify-center rounded-full border border-border-basic-2"
                    :class="isAllowChange ? 'border-primary-3' : ''"
                >
                    <span
                        v-if="isAllowChange"
                        class="h-1.5 w-1.5 rounded-full bg-primary-3"
                    ></span>
                </span>
                <span
                    :class="isAllowChange ? 'font-inter-body-2 text-primary-3' : 'font-inter-body-sm-regular text-content-basic-2'"
                >
                    Allow to change
                </span>
            </button>
        </div>
    </div>
</template>

<script>
import InfoIcon from '@/components/design-system/icon/info.vue';
import ElementsTooltipSingleton from '@/components/elements/ElementsTooltipSingleton.vue';

export default {
    name: 'DesignAllowApproverToggle',
    components: {
        InfoIcon,
        ElementsTooltipSingleton,
    },
    props: {
        modelValue: {
            type: String,
            default: 'N',
        },
        label: {
            type: String,
            default: 'Allow Approver Changes',
        },
        tooltip: {
            type: String,
            default: 'Applicants can change the approver.\nAdmin will be auto-added to CC.',
        },
    },
    emits: ['update:modelValue'],
    computed: {
        isLocked() {
            return this.modelValue === 'N';
        },
        isAllowChange() {
            return this.modelValue === 'Y';
        },
    },
    methods: {
        setValue(value) {
            if (this.modelValue === value) return;
            this.$emit('update:modelValue', value);
        },
        handleTooltipElementReady(ele) {
            if (!ele) return;
            this.__tooltipComponent__hidden__ = ele;
        },
        handleTooltip(ele, msgFn, options) {
            if (!this.__tooltipComponent__hidden__ || !ele) return;
            this.__tooltipComponent__hidden__.loadBasic(ele, msgFn, options);
        },
    },
};
</script>

<style scoped>
</style>

